export const euro = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "";

export const fmtWeight = (g) =>
  g >= 1000 ? `${(g / 1000).toLocaleString("it-IT")} kg` : `${g} g`;

export const parseNum = (v) => parseFloat(String(v).replace(",", "."));

export const CATEGORIES = [
  ["pokemon", "Pokémon"], ["one_piece", "One Piece"], ["dragon_ball", "Dragon Ball"], ["marvel", "Marvel"],
  ["lorcana", "Lorcana"], ["magic", "Magic"], ["giochi", "Giochi"], ["altro", "Altro"],
];

export const LANGS = ["ITA", "JP", "EN", "CN"];
export const TYPES = ["Singolo", "Sigillato", "Box/Display", "Mazzo", "Gradato", "Usato"];
export const HAS_CARD_NUMBER = ["Singolo", "Gradato"];
const LANG_CODE = { ITA: "IT", JP: "JP", EN: "EN", CN: "CN" };
const TYPE_PLURAL = {
  Singolo: "Carte Singole", Sigillato: "Sigillati", "Box/Display": "Box e Display",
  Mazzo: "Mazzi", Gradato: "Carte Gradate", Usato: "Usato",
};

export const categoryPath = (p) => {
  const name = (CATEGORIES.find(([id]) => id === p.category) || [])[1];
  if (!name) return [];
  const code = LANG_CODE[p.language];
  return [name, `${name} (${code})`, `${TYPE_PLURAL[p.condition]} (${code})`];
};

const collator = new Intl.Collator("it", { sensitivity: "base", numeric: true });
const cardNum = (p) => parseInt(String(p.card_number || "").split("/")[0], 10) || Number.MAX_SAFE_INTEGER;
const byName = (x, y) => collator.compare(x.name, y.name);

export const SORTS = [
  ["name_asc", "Nome (A-Z)"], ["name_desc", "Nome (Z-A)"],
  ["price_asc", "Prezzo: dal più basso al più alto"], ["price_desc", "Prezzo: dal più alto al più basso"],
  ["newest", "Più recenti inseriti"], ["set", "Espansione e numero carta"],
];

export function sortProducts(list, key) {
  const a = [...list];
  switch (key) {
    case "name_desc": return a.sort((x, y) => byName(y, x));
    case "price_asc": return a.sort((x, y) => x.price - y.price || byName(x, y));
    case "price_desc": return a.sort((x, y) => y.price - x.price || byName(x, y));
    case "newest": return a.sort((x, y) => (y.created_at || "").localeCompare(x.created_at || ""));
    case "set":
      return a.sort((x, y) => (!x.set_name - !y.set_name) || collator.compare(x.set_name || "", y.set_name || "") || cardNum(x) - cardNum(y) || byName(x, y));
    default: return a.sort(byName);
  }
}

export const USED_GRADES = ["Come nuovo", "Ottimo", "Buono", "Segnato"];
export const USED_TYPES = ["Console", "Gioco", "DVD", "CD", "Fumetto", "Altro"];
export const conditionLabel = (p) => (p.condition === "Usato" ? `Usato · ${p.used_grade}` : p.condition);

export const DOMESTIC = ["IT", "SM", "VA"];

export const COUNTRIES = [
  ["IT", "Italia"], ["SM", "San Marino"], ["VA", "Città del Vaticano"], ["AT", "Austria"],
  ["BE", "Belgio"], ["BG", "Bulgaria"], ["HR", "Croazia"], ["CY", "Cipro"], ["CZ", "Repubblica Ceca"],
  ["DK", "Danimarca"], ["EE", "Estonia"], ["FI", "Finlandia"], ["FR", "Francia"], ["DE", "Germania"],
  ["GR", "Grecia"], ["IE", "Irlanda"], ["LV", "Lettonia"], ["LT", "Lituania"], ["LU", "Lussemburgo"],
  ["MT", "Malta"], ["NL", "Paesi Bassi"], ["PL", "Polonia"], ["PT", "Portogallo"], ["RO", "Romania"],
  ["SK", "Slovacchia"], ["SI", "Slovenia"], ["ES", "Spagna"], ["SE", "Svezia"], ["HU", "Ungheria"],
  ["CH", "Svizzera"], ["GB", "Regno Unito"], ["NO", "Norvegia"], ["US", "Stati Uniti"],
];

export const countryName = (code) => (COUNTRIES.find(([c]) => c === code) || [code, code])[1];

export function methodBlockReason(m, weight, country) {
  if (!m.enabled) return "Non disponibile";
  const domestic = DOMESTIC.includes(country);
  if (m.zone === "IT" && !domestic) return "Solo per l'Italia";
  if (m.zone === "INTL" && domestic) return "Solo per l'estero";
  if (weight > m.max_weight_g) return `Peso oltre il limite (max ${fmtWeight(m.max_weight_g)})`;
  return null;
}

export const shippingText = (o) => {
  const a = o.address;
  return [
    a.full_name,
    a.address,
    `${a.zip} ${a.city}${a.province ? ` (${a.province})` : ""}`,
    countryName(a.country),
    `Tel: ${a.phone}`,
    `Email: ${o.email}`,
  ].join("\n");
};
